import { LoonaLink } from '@loona/core';
export function createLoona(cache) {
    return new LoonaLink({
        cache: cache,
    });
}
//# sourceMappingURL=link.js.map